__turbopack_context__.v({
  "button": "ConsultationForm-module__mlV-7G__button",
  "checkboxField": "ConsultationForm-module__mlV-7G__checkboxField",
  "errorMessage": "ConsultationForm-module__mlV-7G__errorMessage",
  "field": "ConsultationForm-module__mlV-7G__field",
  "form": "ConsultationForm-module__mlV-7G__form",
  "success": "ConsultationForm-module__mlV-7G__success",
  "successButton": "ConsultationForm-module__mlV-7G__successButton",
  "successTitle": "ConsultationForm-module__mlV-7G__successTitle",
});
